export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#arrow-down-strong-2","viewBox":"0 0 32 32"}